import { HelpOutline as NotFoundIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';

const NotFound = () => {
    return <div style={{color: '#888'}}>
        <NotFoundIcon style={{fontSize: "20em"}}/>
        <Typography style={{fontSize: "16pt"}}>Page not found.</Typography>
    </div>;
};

export default NotFound;
